module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-wrap"
  }, [(_vm.context !== 'snapshot') ? _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.title)), (_vm.showAge()) ? _c('span', {
    staticClass: "date-age"
  }, [_vm._v("Age: "), _c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.setAge())
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "date-segment date-segment--month"
  }, [_c('Dropdown', {
    attrs: {
      "id": _vm.setId('date-month'),
      "field": _vm.setField('month'),
      "label": "Month",
      "proto": "months",
      "context": _vm.context
    },
    on: {
      "updateDate": _vm.updateSnapshotDate
    }
  })], 1), _c('div', {
    staticClass: "date-segment date-segment--day"
  }, [_c('Dropdown', {
    attrs: {
      "id": _vm.setId('date-day'),
      "field": _vm.setField('day'),
      "label": "Day",
      "proto": "days",
      "context": _vm.context
    },
    on: {
      "updateDate": _vm.updateSnapshotDate
    }
  })], 1), _c('div', {
    staticClass: "date-segment date-segment--year"
  }, [_c('Dropdown', {
    attrs: {
      "id": _vm.setId('date-year'),
      "field": _vm.setField('year'),
      "label": "Year",
      "proto": _vm.getYears,
      "context": _vm.context
    },
    on: {
      "updateDate": _vm.updateSnapshotDate
    }
  })], 1), _vm._v(" "), (_vm.context === 'snapshot') ? _c('div', {
    staticClass: "date-updater"
  }, [_c('button', {
    staticClass: "date-save",
    on: {
      "click": function($event) {
        _vm.reassignSnapshotDate()
      }
    }
  }, [_vm._v("(save changes)")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f8d1018!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DatePicker.vue
// module id = 323
// module chunks = 0